import React from 'react';
import { Box } from '@chakra-ui/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableItem = ({ id, children, isOptional }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    // Only apply transition while dragging, not after drop to avoid visual "snap back" effect
    transition: isDragging ? transition : undefined,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Box 
      ref={setNodeRef} 
      style={style} 
      {...attributes}
      display="flex" 
      alignItems="center" 
      w="100%"
    >
      {typeof children === 'function' ? children({ dragListeners: listeners, dragAttributes: attributes }) : children}
    </Box>
  );
};

export default SortableItem;

